<template>
  <header id="page-topbar">
    <div class="navbar-header">
      <div class="container-fluid">
        <div class="float-end">
          <div class="dropdown d-inline-block">
            <button
              type="button"
              class="btn header-item waves-effect"
              v-bind:class="{ show: state }"
              data-bs-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
              @click.prevent="toggleDropdown"
            >
              <span class="avatar-title-sm rounded-circle">{{user | initials}}</span>
              <span class="d-none d-xl-inline-block ms-2">{{user | firstAndLast}}</span>
              <i class="mdi mdi-chevron-down d-none d-xl-inline-block"></i>
            </button>
            <div
              class="dropdown-menu dropdown-menu-end active-profile"
              v-bind:class="{ show: state }"
            >
              <!-- item-->
              <a class="dropdown-item" href="#">
                <i class="bx bx-user font-size-16 align-middle me-1"></i>
                Meu perfil
              </a>
              <a class="dropdown-item d-block" href="#">
                <!--<span class="badge bg-success float-end">11</span>-->
                <i class="bx bx-wrench font-size-16 align-middle me-1"></i> Settings
              </a>
              <div class="dropdown-divider"></div>
              <router-link class="dropdown-item text-danger" to="/logout">
                <i class="bx bx-power-off font-size-16 align-middle me-1 text-danger"></i> Logout
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
//UserIcon
export default {
  props: ["user"],
  data() {
    return {
      state: false
    };
  },
  methods: {
    toggleDropdown(e) {
      this.state = !this.state;
    },
    close(e) {
      if (!this.$el.contains(e.target)) {
        this.state = false;
      }
    }
  },
  mounted() {
    document.addEventListener("click", this.close);
  },
  beforeDestroy() {
    document.removeEventListener("click", this.close);
  }
};
</script>
<style scoped>
.avatar-title-sm {
  width: 36px;
  height: 36px;
  background: #45cb85;
  color: #fff;
  display: inline-block;
  border: 3px solid rgba(255, 255, 255, 0.25);
  font-size: 14px;
  line-height: 32px;
}

.active-profile {
  position: absolute;
  inset: 0px 0px auto auto;
  top: 0px;
  right: 0px;
  left: auto;
  margin: 0px;
  transform: translate3d(-0.5px, 72px, 0px);
}
</style>